import { render, staticRenderFns } from "./TosView.vue?vue&type=template&id=47b6f500&scoped=true"
import script from "./TosView.vue?vue&type=script&lang=js"
export * from "./TosView.vue?vue&type=script&lang=js"
import style0 from "./TosView.vue?vue&type=style&index=0&id=47b6f500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b6f500",
  null
  
)

export default component.exports